import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import { IProject } from '../../types';

interface IProps {
	post: IProject;
}

const Project = ({ post }: IProps) => {
	return (
		<a href={post.permalink} target="_self" rel="noreferrer" className="pfa-card-project">
			{!!post.featured_image && (
				<figure
					className="pfa-card-project__figure"
					dangerouslySetInnerHTML={{ __html: post.featured_image }}
				/>
			)}
			<div className="pfa-card-project__content">
				{post.post_title && (
					<h3
						className="pfa-card-project__title"
						dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.post_title) }}
					/>
				)}
				{(!!post.date || !!post.location) && (
					<p className="pfa-card-project__meta">
						{!!post.date && <span className="pfa-card-project__date">{post.date}</span>}
						{!!post.location && (
							<>
								{!!post.date && (
									<span className="pfa-card-project__meta-separator"> | </span>
								)}
								<span className="pfa-card-project__location">{post.location}</span>
							</>
						)}
					</p>
				)}
				{(!!post.service_type || !!post.property_type) && (
					<div className="pfa-card-project__tags">
						{!!post.service_type && (
							<p
								className="pfa-card-project__tag"
								dangerouslySetInnerHTML={{
									__html: sanitizeHtml(post.service_type.name),
								}}
							/>
						)}
						{!!post.property_type && (
							<p
								className="pfa-card-project__tag"
								dangerouslySetInnerHTML={{
									__html: sanitizeHtml(post.property_type.name),
								}}
							/>
						)}
					</div>
				)}
			</div>
		</a>
	);
};

Project.displayName = 'Project';

export default Project;
